import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ISimPublicationKeyDates } from '../../shared/models/document-publication-keyDates';
@Component({
    selector: 'app-document-details-key-dates',
    templateUrl: './document-details-key-dates.component.html',
    styleUrl: './document-details-key-dates.component.scss',
    standalone: false
})
export class DocumentDetailsKeyDatesComponent {
  @Input() SIMPublicationKeyDates: ISimPublicationKeyDates | null = null;
  loading: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['SIMPublicationKeyDates']) {
      this.loading = false;
    }
  }
}
